// extracted by mini-css-extract-plugin
module.exports = {"formBox":"SimpleQuestionnaireCreateEdit_formBox__2_2pF"};